import React from 'react';
import * as Ons from 'react-onsenui';
import Modal from './Modal';
import UserSettings from '../containers/Pages/UserSettings';
import packageJson from '../../../package.json';
import { translate as _ } from '../util/i18n';
import logo from '../../img/logos/dp-logo.png';

class Menu extends React.Component {

    constructor( props ) {

        super( props );

        this.state = {

            userSettingsOpen: false

        };

        this.handleCloseUserSettings = this.handleCloseUserSettings.bind( this );
        this.handleOpenUserSettings  = this.handleOpenUserSettings.bind( this );

    }

    handleCloseUserSettings() {

        this.setState( { userSettingsOpen: false } );

    }

    handleOpenUserSettings() {

        this.setState( { userSettingsOpen: true } );

    }

    render() {

        return (

            <>

                <Ons.Page className="menu">

                    <div className="close" onClick={this.props.onClose}><Ons.Icon icon="fa-times" /></div>

                    <Ons.List>

                        <Ons.ListItem key="userSettings" onClick={this.handleOpenUserSettings}>{_( 'Einstellungen' )}</Ons.ListItem>
                        <Ons.ListItem key="logout" onClick={this.props.onLogout}>{_( 'Ausloggen' )}</Ons.ListItem>

                    </Ons.List>

                    {this.props.username && <div className="logged-in-as">{_( 'Eingelogged als' )} {this.props.username}</div>}

                    <div className="logo"><img src={logo} alt="Logo" /></div>

                    <div className="version">{_( 'Digitaler Spielerpass' )} v{packageJson.version}</div>

                    <div className="copyright">&copy; <a href="https://www.hockeydata.net/" rel="noreferrer" target="_blank">hockeydata</a></div>

                </Ons.Page>

                {this.state.userSettingsOpen && <Modal><UserSettings onClose={this.handleCloseUserSettings} /></Modal>}

            </>

        );

    };

}

export default Menu;